import { useState } from 'react'
import Card from '@mui/joy/Card'
import { TextField } from './ui/TextField'
import FormControl from '@mui/joy/FormControl'
import FormLabel from '@mui/joy/FormLabel'
import Textarea from '@mui/joy/Textarea'
import Input from '@mui/joy/Input'
import Button from '@mui/joy/Button'

export const CampaignForm = ({ onSubmit }) => {
    const [title, setTitle] = useState(null)
    const [aiPrompt, setAiPrompt] = useState(null)

    return (
        <Card
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                maxWidth: 350,
            }}
            variant="outlined"
            color="neutral"
        >
            <TextField
                label="Campaign Title"
                onChange={(e) => setTitle(e.target.value)}
            />
            <FormControl>
                <FormLabel>Describe the type of quotes you'd like</FormLabel>
                <Textarea
                    minRows={8}
                    maxRows={10}
                    onChange={(e) => setAiPrompt(e.target.value)}
                />
            </FormControl>
            <Button
                sx={{ width: '30%', alignSelf: 'flex-end' }}
                disabled={!title || !aiPrompt}
                onClick={() => onSubmit(title, aiPrompt)}
            >
                Submit
            </Button>
        </Card>
    )
}
